/**
 * Base URL of the Tree Tier backend API (no trailing slash).
 *
 * The localhost fallback serves `npm start` only. A production bundle can never reach it: the
 * `prebuild` guard in scripts/check-build-env.js fails the build when REACT_APP_API_URL is absent.
 * That guard matters because CRA inlines the value at compile time — a bundle built without the
 * variable deploys successfully and then points every visitor at their own machine, which is
 * exactly what shipped on 2026-07-27.
 */
export const API_BASE_URL = (process.env.REACT_APP_API_URL ?? "http://localhost:5291").replace(/\/+$/, "");
